import React from 'react';
import { paymentMethods } from '../data/payments';
export function PaymentMethods() {
  return <section className="bg-ink-soft px-5 py-14 lg:px-8 lg:py-20" aria-labelledby="pagos-title" data-id="element-98" data-mp="3lq1d92naya7h">
      <div className="mx-auto max-w-5xl text-center" data-id="element-99" data-mp="3gqey2nnwyjw1">
        <h2 id="pagos-title" className="font-display text-2xl uppercase tracking-[0.12em] text-gold-soft sm:text-3xl" data-id="element-100" data-mp="3gtasi20jyqfq">
          Medios de pago que aceptamos
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-white/65" data-id="element-101" data-mp="36v4s5oue9scz">
          Pagá tu consulta de la forma que te resulte más cómoda y segura.
        </p>

        <ul className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-6" data-id="element-102" data-mp="2y1rqnyi9lifa">
          {paymentMethods.map(method => <li key={method.id} className="flex flex-col items-center gap-3 rounded-2xl border border-gold/15 bg-ink/60 px-4 py-6" data-id="element-103" data-mp="2szsqexhtn1mk">
              <img src={method.logo} alt={method.name} loading="lazy" className="h-16 w-16 rounded-full bg-white object-contain sm:h-20 sm:w-20" data-id="element-104" data-mp="2j50udy3w0mtw" />
              <span className="text-sm font-medium leading-snug text-white/75" data-id="element-105" data-mp="1du216bhphb8q">
                {method.name}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}